import { useCallback } from 'react';

import { useApiKey } from 'hooks/configs/use-api-key';
import useReadyQueue from 'hooks/use-ready-queue';
import logger from 'utils/logger';
import { useMemoAll } from 'utils/use-memo-all';

import { logBranchEvent as externalLogBranchEvent } from './log-branch-event';

export interface IBranch {
  initBranch: () => void;
  logBranchEvent: (eventName: string, customAttributes?: Record<string, any>) => void;
}

const useBranch = () => {
  const { drainQueue } = useReadyQueue();
  const branchKey = useApiKey({ key: 'branch' });

  const initBranch = useCallback(() => {
    import('../init')
      .then(({ default: init }) => {
        init(branchKey, drainQueue);
      })
      .catch(error => {
        logger.error({ error, message: 'Branch: import error' });
      });
  }, [branchKey, drainQueue]);

  const logBranchEvent = externalLogBranchEvent;

  return useMemoAll<IBranch>({ logBranchEvent, initBranch });
};

export default useBranch;

interface IBranchEventAttributes {
  transaction_id?: string;
  currency?: 'USD' | 'CAD';
  revenue?: number;
  tax?: number;
  /** Name of Coupon */
  coupon?: string;
}

declare global {
  interface Window {
    branch?: {
      // https://help.branch.io/developers-hub/docs/tracking-commerce-content-lifecycle-and-custom-events
      logEvent: (eventName: string, eventAttributes?: IBranchEventAttributes) => void;
      disableTracking: (optOutOfBranch: boolean) => void;
    };
  }
}
